import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { DieFace } from '../../face.type';
import { SoundType } from '../../sound';
import { dealDamage, type Player } from '../../player.type';
import type { Die } from '../../die.type';
import type { Technique } from '../../techniques.type';

export class CerberusTrait extends Trait {
  static baseType = TraitType.Cerberus;
  static baseTitle = 'Cerberus Bite';
  static baseText = 'Gain access to the quick bite skill.';
  static baseIcon = 'trait';

  type = CerberusTrait.baseType;
  title = CerberusTrait.baseTitle;
  text = CerberusTrait.baseText;
  icon = CerberusTrait.baseIcon;

  getTechniques(techniques: Technique[]): Technique[] {
    return [
      {
        title: 'Quick Bite',
        text: 'Deal 1 Damage.',
        tags: ['instant', 'damage'],
        ingredients: [DieFace.Bite],
        audio: SoundType.AttackPierce,
        activate: (target: Player, source: Player, dice: Array<Die>) => {
          dealDamage({ value: 1, target, source, dice });
        },
      },
    ];
  }
}

TraitRegistry.register(CerberusTrait.baseType, CerberusTrait);
